import axiosIns from '@/plugins/axios'
import {
  ApiList, ApiDetail, JsonApiResource, JsonApiListResponse,
} from '@/api/v2/types/json-api'
import { AggregationResultAttributes } from '@/api/v2/types/aggregation-result'

export interface AggregationContainerAttrs {
  id: number
  name: string
  description?: string
  type: string
}
export interface AggregationAttrs {
  id: number
  type: string
  name: string
  description: string
  position: number
  transpose: boolean,
}
export interface AggregationContainerDetailAttrs {
  id: number
  name: string
  description?: string
  type: string
  rows: JsonApiListResponse<JsonApiResource<'aggregationContainerRow', {
    id: number
    name: string
    position: number
    cols: JsonApiListResponse<JsonApiResource<'aggregationContainerCols', {
      id: number
      name: string
      position: number
      aggregations: JsonApiListResponse<JsonApiResource<'aggregation', AggregationAttrs>>
    }>>
  }>>
}

export type AggregationContainerListResponse =
  ApiList<AggregationContainerAttrs, 'aggregationContainers'>

export type AggregationContainerDetailResponse =
  ApiDetail<AggregationContainerDetailAttrs, 'aggregationContainers'>

/** 一覧取得 */
export async function fetchAggregationContainers(): Promise<AggregationContainerAttrs[]> {
  const res = await axiosIns.get<AggregationContainerListResponse>(
    '/v2/report/aggregation_containers',
  )

  return res.data.data.data.map(r => r.attributes)
}

/** 詳細取得 */
export async function fetchAggregationContainer(
  id: number,
): Promise<AggregationContainerDetailAttrs> {
  const res = await axiosIns.get<AggregationContainerDetailResponse>(
    `/v2/report/aggregation_containers/${id}`,
  )

  return res.data.data.data.attributes
}
